import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;
const id = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const creatorId = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const firmId =
  JSON.parse(localStorage.getItem("authUser"))?.response?.adminId ||
  JSON.parse(localStorage.getItem("authUser"))?.response?.firmId;
const Role = JSON.parse(localStorage.getItem("authUser"))?.response?.role;

const createAxiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: token ? `Bearer ${token}` : null,
  },
});

const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);

// auth services 

// FORGET PASSWORD
export const forgetPasswordApi = async (data) => {
  try {
    const response = await axiosInstance.post("/auth/forget-password", data);
    return response;
  } catch (error) {
    throw error;
  }
};

// RESET PASSWORD
export const resetPasswordApi = async (data) => {
  try {
    const response = await axiosInstance.post("/auth/reset-password", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateUserById = async (id, updateData) => {
  try {
    const response = await axiosInstance.put(`/auth/update/${id}`, updateData);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get all leads
export const getAllLeads = async () => {
  try {
    const response = await axiosInstance.get("/lead/get-leads");
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get all leads by firm id
export const getLeadsByFirmId = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/lead/get-lead-by-firm/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// lead by id
export const getLeadById = async (id) => {
  try {
    const response = await axiosInstance.get(`/lead/get-lead/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to add lead
export const addLead = async (lead) => {
  try {
    const response = await axiosInstance.post("/lead/create-lead", lead);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to update lead
export const updateLeadById = async (id, lead) => {
  try {
    const response = await axiosInstance.put(`/lead/update-lead/${id}`, lead);
    return response.data;
  } catch (error) {
    return error;
  }
};
// to delete lead
export const deleteLeadById = async (id) => {
  try {
    const response = await axiosInstance.delete(`/lead/delete-lead/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};
// multiple delete leads
export const deleteMultipleLeads = async (data) => {
  try {
    const response = await axiosInstance.delete("/lead/delete-multiple-leads", {
      data,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// to assign lead to employee
export const assignLeadsToEmployee = async (data) => {
  try {
    const response = await axiosInstance.post("/task/create-task", data);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get firm users
export const getFirmUsers = async () => {
  try {
    const response = await axiosInstance.get("/auth/getCompany");
    return response.data;
  } catch (error) {
    return error;
  }
};

// ro get company for admin
export const getCompanyForAdmin = async (id) => {
  try {
    const response = await axiosInstance.get(`/auth/getCompany/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get user id data using crmuser id
export const getCrmUserById = async () => {
  try {
    const response = await axiosInstance.get(`crmuser/crmsuser-account/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get tasks
export const getAllTasks = async () => {
  try {
    const response = await axiosInstance.get("/task/get-tasks");
    return response.data;
  } catch (error) {
    return error;
  }
};

// get tasks by firmId

export const getTasksByFirmId = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/task/get-task-by-firm/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// to update the task
export const updateTask = async (id, task) => {
  try {
    const response = await axiosInstance.put(`/task/update-task/${id}`, task);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to reassign task to employee
export const updateAssignees = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/task/update-assignee/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//to update task
export const updateTaskOrLead = async (id, updateData) => {
  try {
    const response = await axiosInstance.put(
      `/task/update-task/${id}`,
      updateData
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// get tasks by assignee id
export const getTasksByAssignee = async (id) => {
  try {
    const response = await axiosInstance.get(`/task/assignedto/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

//   role management
export const getRoles = async () => {
  try {
    const response = await axiosInstance.get("/role/get-roles");
    const filteredRoles = response.data.data.filter(
      (role) => role.deleted_at === null
    );
    // console.log(filteredRoles);
    return filteredRoles;
  } catch (error) {
    return error;
  }
};

// to create role
export const createRole = async (role) => {
  try {
    const response = await axiosInstance.post("/role/create-role", role);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.message || "Failed to create role");
    }
    throw new Error("Network error or server not responding");
  }
};

// update role
export const updateRoleById = async (id, role) => {
  try {
    const response = await axiosInstance.put(`/role/update-role/${id}`, role);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to delete role
export const deleteRoleById = async (id) => {
  try {
    const response = await axiosInstance.delete(`/role/delete-role/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to create crm users
export const createCrmUser = async (user) => {
  try {
    const response = await axiosInstance.post(
      `/crmuser/create-crmsuser/${creatorId}`,
      user
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
// to update crm users
export const updateCrmUser = async (userId, user) => {
  try {
    const response = await axiosInstance.put(
      `/crmuser/update-crmsuser/${userId}`,
      user
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// update crm user password
export const updateCrmUserPassword = async (passwordData) => {
  try {
    const response = await axiosInstance.post(
      `/crmuser/update-crmpassword/${id}`,
      passwordData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating CRM user password:", error);
    throw error.response?.data || error;
  }
};

// to get crm users
export const getCrmUsers = async (firmId) => {
  try {
    const response = await axiosInstance.get(`/crmuser/get-crmsuser/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to upload leads by xlsx , csv , json
export const uploadLeads = async (data) => {
  try {
    const response = await axiosInstance.post("/lead/importLead", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
export const createUser = async (data, clientId) => {

    const response = await axiosInstance.post(
      `/auth/createUser/${clientId}`, data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );  
    return response;

};


//  to export leads
export const exportLeads = async (data) => {
  try {
    const response = await axiosInstance.post("/lead/exportLead", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

//  update lead status by userId and leadId
export const updateLeadStatus = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/lead/update-leadstatus/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    return error.response ? error.response.data : error;
  }
};

//  get firm data using id
export const getFirmById = async () => {
  try {
    const response = await axiosInstance.get(`/auth/getfirm/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};
export const getCompanyData = async (firmId) => {
  try {
    const response = await axiosInstance.get(`/auth/getfirm/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// get all plans
export const getAllPlans = async () => {
  try {
    const response = await axiosInstance.get("/plan/all");
    return response.data.response;
  } catch (error) {
    return error;
  }
};
export const demoUserLogin = async (email, token) => {
  try {
    const response = await axiosInstance.post("/auth/login", {
      email,
      token,
    });
    return response.data.response;
  } catch (error) {
    return error?.response?.data || { message: "Demo login failed" };
  } 
};
//  to approve status of client
export const approveClient = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/auth/approveClient/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response ? error.response.data : error;
  }
};

//  to inactive status of client
export const inactiveClient = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/auth/userInactive/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response ? error.response.data : error;
  }
};

//  blogcategory create api

export const createBlogCategory = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/blogcategory/create-blogCategory/${id}`,
      data
    );
    console.log(id);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get all blog categories
export const getBlogCategories = async () => {
  try {
    const response = await axiosInstance.get(
      "/blogcategory/get-blogcategories"
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get single blog category by id
export const getBlogCategoryById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/blogcategory/get-blogCategory/${id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// to update blog category

export const updateBlogCategory = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/blogcategory/update-blogCategory/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// to delete blog category
export const deleteBlogCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `/blogcategory/delete-blogCategory/${id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// to create blog
export const createBlog = async (data) => {
  try {
    const response = await createAxiosInstance.post(`/blog/create-blog`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get all blogs
export const getBlogs = async () => {
  try {
    const response = await axiosInstance.get("/blog/get-blogs");
    return response.data;
  } catch (error) {
    return error;
  }
};

// to get blog by Id
export const getBlogById = async (id) => {
  try {
    const response = await axiosInstance.get(`/blog/get-blog/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to update blog by id
export const updateBlog = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/blog/update-blog/${id}`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};

// get blogs by blog_slug
export const getBlogBySlug = async (slug) => {
  try {
    const response = await axiosInstance.get(`/blog/get-blog-slug/${slug}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// to delete blog by id
export const deleteBlog = async (id) => {
  try {
    const response = await axiosInstance.delete(`/blog/delete-blog/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// feedback api services

export const createFeedback = async (data) => {
  try {
    const response = await createAxiosInstance.post(
      `/feedback/create-feedback`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getAllFeedbacks = async () => {
  try {
    const response = await axiosInstance.get("/feedback/get-feedbacks");
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getFeedbackById = async (id) => {
  try {
    const response = await axiosInstance.get(`/feedback/get-feedback/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateFeedback = async (id, data) => {
  try {
    const response = await createAxiosInstance.put(
      `/feedback/update-feedback/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteFeedbackById = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `/feedback/delete-feedback/${id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// get item category
export const getItemCategories = async () => {
  try {
    const response = await axiosInstance.get(
      `/category/get-categories/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getItemSubCategories = async (categoryId) => {
  try {
    const response = await axiosInstance.get(
      `/category/subcategories/${categoryId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getVendors = async () => {
  try {
    const response = await axiosInstance.get(`/vendor/get-vendors/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getBrands = async () => {
  try {
    const response = await axiosInstance.get(`/brand/get-brands/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getTaxes = async () => {
  try {
    const response = await axiosInstance.get(`/tax/get-taxes/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getBoms = async (firmId) => {
  try {
    const response = await axiosInstance.post(`/bom/get-bom`, {
      firmId,
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getInventoryItems = async (firmId) => {
  try {
    const response = await axiosInstance.get(`/inventory/get-items/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateInventoryItemById = (id, payload) =>
  axiosInstance.put(`/inventory/update-item/${id}`, payload).then(res => res.data);

export const createBom = async (data) => {
  try {
    const response = await axiosInstance.post(`/bom/create-bom`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};

//get all production orders using firmId in the body , post api
export const getProductionOrders = async () => {
  try {
    const response = await axiosInstance.post(
      `/productionorder/get-productionorders`,
      {
        firmId,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
// get production order by id
export const getProductionOrderById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/productionorder/get-productionorder/${id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// create production order
export const createProductionOrder = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/productionorder/create-productionorder`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// update production order quantity
export const updateProductionOrderQuantity = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/productionorder/update-productionorder/${id}`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// update production order status
export const updateProductionOrderStatus = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `/productionorder/update-productionorderstatus/${id}`,
      data
    );
    return response;
  } catch (error) {
    return error;
  }
};

// to get firm wise wastage
export const getFirmWastage = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/wasteinventory/get-wasteManagments/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getWastageById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/wasteinventory/get-wasteManagment/${id}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// get customers for firm
export const getCustomers = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/customer/get-customers/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
// update customer
export const updateCustomer = async (customerId, customerData) => {
  try {
    const response = await axiosInstance.put(
      `/customer/update-customer/${customerId}`,
      customerData
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getItemCategoriesmain = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/category/get-categories/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getVendorsmain = async (firmId) => {
  try {
    const response = await axiosInstance.get(`/vendor/get-vendors/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getBrandsmain = async (firmId) => {
  try {
    const response = await axiosInstance.get(`/brand/get-brands/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getProductionOrdersmain = async (firmId) => {
  try {
    const response = await axiosInstance.post(
      `/productionorder/get-productionorders`,
      {
        firmId,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
export const getTaxesmain = async (firmId) => {
  try {
    const response = await axiosInstance.get(`/tax/get-taxes/${firmId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPaymentDetails = async () => {
  try {
    const response = await axiosInstance.get(`/payment/payment-detail/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};
export const getPaymentDetailsMain = async (id) => {
  try {
    const response = await axiosInstance.get(`/payment/payment-detail/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createBilling = async (data) => {
  try {
    const response = await axiosInstance.post(`/billing/create-bill`, data);
    return response;
  } catch (error) {
    return error;
  }
};
export const createItem = async (data, createdBy) => {
    const response = await axiosInstance.post(`/inventory/create-item/${createdBy}`, data);
    return response;
};
// get firm bills by firm Id
export const getFirmBills = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/billing/get-bills-by-firm/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//  Set Permissions (POST)
export const setUserPermissions = async (userId, sidebarAccess) => {
  try {
    const response = await axiosInstance.post(
      `/auth/set-permissions/${userId}`,
      {
        sidebarAccess,
      }
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//   Get Permissions (GET)

export const getUserSidebar = async (userId) => {
  try {
    const response = await axiosInstance.get(`/auth/get-sidebar/${userId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// Query Form Request (POST)
export const QueryFormRequest = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/blog/create-contact-message`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// Send Contact OTP Request (POST)
export const SendContactOtpRequest = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/blog/send-contact-otp`,
      data
    );
    return response.data;
  } catch (error) {
    return error;
  }
};


// Get All Contact Messages (GET)
export const getAllContactMessages = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `/blog/get-all-contact-messages?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// get user services for inventory creation

export const getUserServices = async (firmId) => {
  try {
    const response = await axiosInstance.get(
      `/inventory/user-services/${firmId}`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

// create firmIndustryService
export const createFirmIndustryService = async (data) => {
  try { 
    const response = await axiosInstance.post(
      "/inventory/create-user-industry",
      data
    );
    return response.data;
  } catch (error) {
    // console.error("Error creating firm industry service:", error);
    throw error.response?.data || error;
  }
};

// get clients data for the dashboard
export const clientDashboard = async (userId) => {
  try {
    const response = await axiosInstance.get(`/inventory/get-count-condition/${userId}`);
    return response.data;
  }
  catch (error) {
    console.error("Error fetching client dashboard data:", error);
    throw error.response?.data || error;
  }
}
// for firm users dashboard 
export const firmUsersDashboard = async (userId) => {
  try {
    const response = await axiosInstance.get(`/inventory/get-count-condition-firm/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching firm users dashboard data:", error);
    throw error.response?.data || error;
  }
};

// for Super Admin dashboard
export const superAdminDashboard = async (userId) => {
  try {
    const response = await axiosInstance.get(`/role/getData/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching firm users dashboard data:", error);
    throw error.response?.data || error;
    
  }
};


export const getInvoiceById = async (id) => {
    try {
        const response = await axiosInstance.get(`/invoice/get-invoice/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching invoice:", error);
        throw error;
    }
};

// ✅ Update invoice by ID
export const updateInvoiceById = async (id, updatedInvoiceData) => {
    try {
        const response = await axiosInstance.put(`/invoice/edit-invoice/${id}`, updatedInvoiceData);
        return response.data;
    } catch (error) {
        console.error("Error updating invoice:", error);
        throw error;
    }
};

export const rejectInvoiceById = async (id) => {
    const response = await axiosInstance.put(`/invoice/reject-invoice/${id}`);
    return response.data;
};
export const deleteFirm = async (firmId) => {
    const response = await axiosInstance.delete(`/auth/delete-firm/${firmId}`);
    return response;
};


// Razorpay Integration 
export const createRazorPayment = async (data) => {
  try { 
    const response = await axiosInstance.post(
      "/payment/razorpay/create-order",
      data
    );
    return response.data;
  } catch (error) {
    // console.error("Error creating firm industry service:", error);
    throw error.response?.data || error;
  }
};
export const verifyRazorPayment = async (data) => {
  try {
    const response = await axiosInstance.post(
      "/payment/verify",   // maps to http://localhost:7200/api/payments/verify
      data
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSettings = async()=>{
  try{
    const response = await axiosInstance.get('/settings/get-settings')
    return response.data;
  }catch(error){
    throw error;
  }
}
export const updateSettings = async (id, payload) => {
  try {
    const response = await axiosInstance.post(`/settings/update-settings/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createDemoUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/demo/create-demo-user", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginDemoUser = async (payload) => {
  try {
    const response = await axiosInstance.post("/auth/login", payload);
    console.log(response.data)
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDemoUserList = async (payload) => {
  try {
    const { page = 1, limit = 10 } = payload;
    const response = await axiosInstance.post(`/auth/get-demouser`, { page, limit });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDemoUserExpiry = async (payload) => {
  try {
    const response = await axiosInstance.put("/auth/demoUser-ExpiryUpdate", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllDemoUserLogs = async () => {
  try {
    const response = await axiosInstance.get("/auth/get-all-demouser-logs");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDemoUserLogsById = async (userId) => {
  if (!userId) throw new Error("userId is required");
  try {
    const response = await axiosInstance.get(`/auth/get-demouser-logs/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
// FAQ Section 

// FAQ APIs using slug
export const createFAQ = async (faqData) => {
  try {
    const response = await axiosInstance.post("/faqs/create-faq", faqData);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getAllFAQs = async () => {
  try {
    const response = await axiosInstance.get("/faqs/all-faqs");
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getFAQBySlug = async (slug) => {
  try {
    const response = await axiosInstance.get(`/faqs/${slug}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const updateFAQ = async (slug, faqData) => {
  try {
    const response = await axiosInstance.put(`/faqs/${slug}`, faqData);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const deleteFAQ = async (slug) => {
  try {
    const response = await axiosInstance.delete(`/faqs/${slug}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

// ================= TEAM USERS =================

// CREATE USER
export const createUserApi = async (data) => {
  try {
    const res = await axiosInstance.post("/team-ops/create-user", data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// GET ALL USERS
export const getAllUsersApi = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/team-ops/users", { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// GET USER BY ID
export const getUserByIdApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/team-ops/user/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE USER
export const updateUserApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(`/team-ops/update-user/${id}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// DELETE USER (SOFT DELETE)
export const deleteUserApi = async (id) => {
  try {
    const res = await axiosInstance.delete(`/team-ops/delete-user/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// RESTORE USER
export const restoreUserApi = async (id) => {
  try {
    const res = await axiosInstance.put(`/team-ops/restore-user/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// TOGGLE STATUS
export const toggleUserStatusApi = async (id) => {
  try {
    const res = await axiosInstance.put(`/team-ops/toggle-user-status/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

// RESET PASSWORD (ADMIN)
export const resetUserPasswordApi = async (id, password) => {
  try {
    const res = await axiosInstance.put(`/team-ops/reset-password/${id}`, {
      password,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// ASSIGN ROLE
export const assignRoleApi = async (id, role) => {
  try {
    const res = await axiosInstance.put(`/team-ops/assign-role/${id}`, {
      role,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// ASSIGN TEAM (DEPARTMENT + DESIGNATION)
export const assignTeamApi = async (id, departmentId, designationId) => {
  try {
    const res = await axiosInstance.put(`/team-ops/assign-team/${id}`, {
      departmentId,
      designationId,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// ================= DROPDOWNS =================

// GET DEPARTMENTS
export const getDepartmentsApi = async () => {
  try {
    const res = await axiosInstance.get("/department/getAll");
    return res.data;
  } catch (error) {
    throw error;
  }
};
// department by id 
export const getDesignationsByDepartmentApi = async (departmentId) => {
  try {
    const res = await axiosInstance.get(`/designation/by-department/${departmentId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getUsersApi = async () => {
  try {
    const res = await axiosInstance.get("/adminWork/users");
    // await axiosInstance.get(`/designation/by-department/${departmentId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export default axiosInstance;


